import { render, staticRenderFns } from "./taskHistoryDialog.vue?vue&type=template&id=9dd9b3a6&"
import script from "./taskHistoryDialog.vue?vue&type=script&lang=js&"
export * from "./taskHistoryDialog.vue?vue&type=script&lang=js&"
import style0 from "./taskHistoryDialog.vue?vue&type=style&index=0&id=9dd9b3a6&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports